import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';

import { Filter, Main } from 'Containers';
import { LoadingPage } from 'Components';
import ImportPicturesForm from './ImportPicturesForm';
import { ImportPicturesFieldEnum } from 'Common/FieldEnum';
import { IMPORT_PICTURES_FORM_NAME } from 'Common/FormEnum';
import { toastError, toastSuccess } from 'Common/ToastHelper';
import { postGenericFile } from 'State/generic/actions';

class ImportPicturesComponent extends Component {
  state = { loading: false };

  getMainProps = () => {
    const { loading } = this.state;

    return {
      toolbox: {
        formName: IMPORT_PICTURES_FORM_NAME,
        saveButtonProps: {
          content: 'Upload',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = async (values, disptch, props) => {
    const formData = new FormData();
    formData.append(
      ImportPicturesFieldEnum.File,
      values[ImportPicturesFieldEnum.File][0]
    );
    formData.append(
      ImportPicturesFieldEnum.UseServingNumber,
      Number(values[ImportPicturesFieldEnum.UseServingNumber])
    );
    try {
      await this.props.postGenericFile('student/picture/zip', formData, true);
    } catch (e) {
      toastError(e.response.data.Errors[0].Message);
      throw new SubmissionError({
        _error: e.response.data.Errors[0].Message,
      });
    }

    //Reset the file input field.
    try {
      this.state.fileInputRef.current.inputRef.current.value = '';
    } catch (e) {}

    toastSuccess('Picture import queued');
  };

  handleFileInputRef = ref => {
    this.setState({ fileInputRef: ref });
  };

  render() {
    const { loading } = this.state;

    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'Import Pictures'} />
        <Main {...this.getMainProps()}>
          <ImportPicturesForm
            initialValues={{
              [ImportPicturesFieldEnum.UseServingNumber]: false,
              [ImportPicturesFieldEnum.File]: null,
            }}
            onSubmit={this.handleSubmit}
            refCallback={this.handleFileInputRef}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  postGenericFile,
};

export const ImportPictures = connect(
  () => ({}),
  mapDispatchToProps
)(ImportPicturesComponent);



// WEBPACK FOOTER //
// ./src/pages/importpictures/ImportPictures.js